export default function* colorGen() {
  const colors = [
    { borderColor: 'rgb(255, 99, 132)', backgroundColor: 'rgba(255, 99, 132, 0.5)' },
    { borderColor: 'rgb(53, 162, 235)', backgroundColor: 'rgba(53, 162, 235, 0.5)' },
    { borderColor: 'rgb(50, 162, 100)', backgroundColor: 'rgba(50, 162, 100, 0.5)' },
  ];
  while (true) yield* colors;
}
